const PageNotFound = () => {
  return (
    <div className="flex-row ht-90vh">
      <img
        className="align-center"
        src="https://cdn.discordapp.com/attachments/893545064062660641/963868082298826782/undraw_Page_not_found_re_e9o6_1.png"
        alt="404 page not found"
      />
    </div>
  );
};

export { PageNotFound };
